
import React, {FC} from 'react';
import classNames from 'classnames';
import CanvasComposite from 'templates/reports/Section/ScanImages/CanvasComposite';
import CanvasSingle from 'templates/reports/Section/ScanImages/CanvasSingle';
import SaveImage from 'templates/reports/Section/ScanImages/SaveImage';
import {Colors} from 'templates/reports/Section/ScanImages/useColors';
import {Images, ImageType} from 'templates/reports/Section/ScanImages/useImages/query';
import {sortkey} from 'utils/sort';

import {useSelect} from './select';
import Selector from './Selector';

import * as styles from './styles.module.scss';
import * as snaps from 'templates/reports/Section/Snapshot/styles.module.scss';

type HistoryProps = {
	images: Images[]
	colors: Colors
}

const ImageHistory: FC<HistoryProps> = ({images, colors}) => {
	const select = useSelect(colors);
	const config = colors.config(select.active as ImageType);
	const mapped = images
		.map((images, i) => {
			if (select.composite) {
				const sorted = [...images.images].sort(
					sortkey((img) => colors.config(img.type)?.order)
				);
				return (
					<SaveImage title={images.start.date} key={i}>
						{(canvas) => (
							<CanvasComposite
								canvas={canvas}
								images={sorted}
								config={colors.config}
							/>
						)}
					</SaveImage>
				);
			}

			const image = images.images.find((img) => img.type === select.active);
			return image && config && (
				<SaveImage title={images.start.date} key={i}>
					{(canvas) => (
						<CanvasSingle
							canvas={canvas}
							image={image}
							config={config}
						/>
					)}
				</SaveImage>
			);
		});

	return (
		<>
			<div className={snaps.header}>
				<h2>Images over time</h2>
			</div>
			<p>
				Select an image type to see how your body composition has
				changed across all your scans.
			</p>
			<Selector select={select} />

			<div key={colors.counter} className={classNames({
				[styles.history]: true,
				[styles.minFour]: mapped.length >= 4,
			})}>
				{mapped}
			</div>
		</>
	);
};

export default ImageHistory;
